import { useOutletContext } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useAdvisorShares } from "../hooks/useAdvisorShares";
import { AdvisorActivityTable } from "../components/AdvisorActivityTable";

export const AdminProjectAdvisorShares = () => {
    const { project, reloadProjectData } = useOutletContext<any>();
    const { activities, fetched, error, reloadActivities } = useAdvisorShares(project.id);

    if (!fetched) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading activities: {error.message}</div>;
    }

    return (
        <div className="admin-screen">
            <div className="admin-table-header">
                <h5>Project Advisor Activities</h5>
            </div>

            <Box sx={{ mb: 4 }}>
                <Typography variant="body1" gutterBottom>
                    Manage project-specific activities and share allocations for advisors. These activities will override the default activities for this project.
                </Typography>
            </Box>

            <AdvisorActivityTable projectId={project.id} />
        </div>
    );
}; 